import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { MyCompanyAuthenticationData } from '../../../types/company-data';
import { TemplateState } from '../../../../types/common/types';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { Subscription } from 'rxjs';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { CompanyAuthenticationFormWebComponent } from '../../authenticationSettingsForm';
import {
  WEB_COMPONENT_COMPANY_AUTHENTICATION_FORM,
  WEB_COMPONENT_GZ_INFO_BOX,
} from '../../../../webcomponents.constants';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { toggleVisibility } from '../../../../utils/htmlElement.utils';
import { ButtonColors } from '../../../../ui/gzButton/types';
import { CompanyEditingRight } from '../../types/CompanyEditingRight';
import _ from 'lodash';
import { GzInfoBoxWebComponent } from '../../../../ui/gzInfoBox';
import { InfoBoxSeverity } from '../../../../ui/gzInfoBox/types';

export class CompanyAuthenticationTabView extends BaseWebComponentView {
  public formGroup!: FormGroup;
  private formGroupValidSubscription: Subscription | null = null;

  public dom: {
    $wrapper: HTMLElement;

    $readonlyNotice: GzInfoBoxWebComponent;
    $authenticationForm: CompanyAuthenticationFormWebComponent;

    $saveButton: GzButtonWebComponent;
    $cancelButton: GzButtonWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),

      $readonlyNotice: this.shadow.querySelector(WEB_COMPONENT_GZ_INFO_BOX),
      $authenticationForm: this.shadow.querySelector(WEB_COMPONENT_COMPANY_AUTHENTICATION_FORM),

      $saveButton: this.shadow.querySelector('#save-button'),
      $cancelButton: this.shadow.querySelector('#cancel-button'),
    };

    this.setLoadingState();

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$readonlyNotice.severity = InfoBoxSeverity.INFORMATIVE;
    this.dom.$readonlyNotice.innerHTML = this.commonStrings.readOnlyNotice;

    this.dom.$saveButton.innerHTML = this.commonStrings.save;
    this.dom.$cancelButton.innerHTML = this.commonStrings.cancel;
  }

  buildSuccessView({
    authData,
    editingRight,
  }: {
    authData: MyCompanyAuthenticationData;
    editingRight: CompanyEditingRight;
  }) {
    const readOnly = _.includes([CompanyEditingRight.Partial, CompanyEditingRight.None], editingRight);

    this.dom.$authenticationForm.injectDependencies(this.dependencies);
    this.dom.$authenticationForm
      .start()
      .then(() => {
        // set form data
        this.dom.$authenticationForm.setFormValue(authData);

        // get form group
        this.formGroup = this.dom.$authenticationForm.getFormGroup();
        this.setAuthenticationTabToDisabled(readOnly);

        // subscribe to form valid$
        this.formGroupValidSubscription = this.formGroup.valid$.subscribe({
          next: valid => {
            this.dom.$saveButton.disabled = !valid || readOnly;
          },
        });

        this.removeLoadingState();
      })
      .catch(console.error);
  }

  buildErrorView() {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
    this.buildEmptyTemplate();
  }

  private setAuthenticationTabToDisabled(readOnly: boolean) {
    if (!readOnly) {
      return;
    }

    this.dom.$authenticationForm.setFormGroupToDisabled();
    this.dom.$cancelButton.color = ButtonColors.SECONDARY;

    toggleVisibility(this.dom.$readonlyNotice, true);
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }

  private buildEmptyTemplate() {
    this.dom.$wrapper.innerHTML = '';
  }

  protected onDisconnect() {
    this.formGroup?.unsubscribe();
    this.formGroupValidSubscription?.unsubscribe();
  }

  public discardFormChanges() {
    this.dom.$authenticationForm.canShow2FaDialog = false;
    this.formGroup.discardChanges();
    this.dom.$authenticationForm.canShow2FaDialog = true;
  }
}
